/**
 * Centralized query keys for Facilities feature.
 * Used by FacilityDrawer, FacilityDetails,
 * OpportunityForm, ProviderFacilityDetailsFull, etc.
 */

// List
export const FACILITIES_LIST_QUERY_KEY = 'organization-facilities-list';

// Selected facility (detail, specialties, contacts)
export const FACILITY_QUERY_KEY = 'facility';
export const FACILITY_SPECIALTIES_QUERY_KEY = 'facility-specialties';
export const FACILITY_CONTACTS_QUERY_KEY = 'facility-contacts';

// Global (not facility-specific)
export const FACILITY_TYPE_FIELDS_QUERY_KEY = 'facility-type-fields';
